import { doc, serverTimestamp, setDoc } from 'firebase/firestore';
import i18n from './index';
import { db } from '../lib/firebase';
import { cacheUiLanguage, type UiLanguage } from './uiLanguage';

/** 表示言語を適用する。DB には書かない。cache を false にすると localStorage は更新しない。 */
export function commitUiLanguage(next: UiLanguage, options?: { cache?: boolean }): void {
  if (options?.cache !== false) cacheUiLanguage(next);
  if (typeof document !== 'undefined') {
    document.documentElement.lang = next;
  }
  if (!i18n.language?.startsWith(next)) {
    void i18n.changeLanguage(next);
  }
}

/** ログインユーザーが選んだ表示言語を users/{uid}.uiLanguage に保存する。 */
export async function saveUiLanguage(uid: string, next: UiLanguage): Promise<void> {
  await setDoc(
    doc(db, 'users', uid),
    {
      uiLanguage: next,
      updatedAt: serverTimestamp(),
    },
    { merge: true },
  );
}
